import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAllBuyManagers } from '../store/slices/buyManager/buyManagers';
import { useLazyGetAllBuyManagersQuery } from '../services/buyManagersApi';
import { fetchAllPages } from '../utils/requestUtils';

export const useBuyManagers = () => {
  const [isLoading, setIsLoading] = useState(false);
  const buyManagers = useSelector(selectAllBuyManagers);
  const [getAllBuyManagers] = useLazyGetAllBuyManagersQuery();

  useEffect(() => {
    const fetchBuyManagers = async () => {
      if (!buyManagers) {
        setIsLoading(true);
        try {
          await fetchAllPages(getAllBuyManagers, "buyManagers");
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchBuyManagers();
  }, [buyManagers, getAllBuyManagers]);

  return { buyManagers, isLoading };
};
